export class ChatPeerDetails {
   public constructor(public name: string, public email: string) {
      // nothing to do
   }
}
